const WORDS = [
  "Precision",
  "Presentation",
  "Protection",
  "Gloss",
  "Craftsmanship",
  "Exclusivity",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-white/5 bg-charcoal py-6 overflow-hidden"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-3xl sm:text-4xl lg:text-5xl text-transparent [-webkit-text-stroke:1px_rgba(201,162,39,0.45)] px-8">
              {w}
            </span>
            <span className="text-gold/60 text-2xl">✦</span>
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-charcoal to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-charcoal to-transparent" />
    </div>
  );
}
